import { useDeepCompareEffect } from 'react-use';
import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setThroughputSelectedEpics } from '../../../../../store/strategy-store/strategy-store.actions';
import { FiltersListEpics } from '../../components/filters-list/filters-list-epics';
import { MAX_SELECTION } from '../../initiative-performance.constants';
import { useContributingEpics } from '../../initiative-performance.hooks';

export const FiltersEpics = () => {
  const contributingEpics = useContributingEpics();
  const selectedEpics = useThroughputTabStore((state) => state.selectedEpics);

  useDeepCompareEffect(() => {
    if (contributingEpics.length > 0) {
      setThroughputSelectedEpics(contributingEpics.slice(0, MAX_SELECTION));
    }
  }, [contributingEpics]);

  return (
    <FiltersListEpics
      epics={contributingEpics}
      selectedEpics={selectedEpics}
      onSelectEpics={setThroughputSelectedEpics}
    />
  );
};
